import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export interface ViewDetailsSkeletonSection {
  fields: number;
  showMap?: boolean;
}

@Component({
  selector: 'app-view-details-skeleton',
  templateUrl: './view-details-skeleton.component.html',
  styleUrls: ['./view-details-skeleton.component.scss']
})
export class ViewDetailsSkeletonComponent implements OnChanges {
  @Input() leftFields = 10;
  @Input() rightSections: ViewDetailsSkeletonSection[] = [{ fields: 4 }];

  leftFieldRows: number[] = [];
  rightSectionModels: { fields: number[]; showMap: boolean }[] = [];

  constructor() {
    this.rebuildArrays();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['leftFields'] || changes['rightSections']) {
      this.rebuildArrays();
    }
  }

  private rebuildArrays(): void {
    this.leftFieldRows = new Array(Math.max(1, this.leftFields || 1));
    const sections = this.rightSections?.length ? this.rightSections : [{ fields: 4 }];
    this.rightSectionModels = sections.map((section) => ({
      fields: new Array(Math.max(1, section?.fields || 1)),
      showMap: !!section?.showMap
    }));
  }
}
